import {TimeTrackerService} from '../app/time-tracker-service.service';
import {Field} from './crud/Field';
import {Config} from './crud/Config';
import {ModalFields} from './modal-fields';

export class Device {
    public id: string;
    public userId: string;
    public isCompanyDevice: boolean;
    public name: string;
    public mac: string;

    public static PHONE = 'PHONE';
    public static TABLET = 'TABLET';

    constructor() {
        this.id = null;
        this.isCompanyDevice = false;
        this.name = 'PHONE';
        this.mac = '';
    }

    public static toModelTemplate(device: Device) {
        const path = TimeTrackerService.USER_DEVICES;

        const idField = new Field('id', 'id', 'text', false);
        const userIdField = new Field('UserId', 'userId', 'text', false);
        const isCompanyDeviceField = new Field('Company', 'isCompanyDevice', 'checkbox', false);
        const nameField = new Field('MODEL.DEVICE.NAME', 'name', 'select', true);
        const macField = new Field('MODEL.DEVICE.MAC', 'mac', 'text', true);

        nameField.entries = [
            {key: this.PHONE, value: 'PHONE'},
            {key: this.TABLET, value: 'TABLET'}
        ];

        idField.hidden = true;
        userIdField.hidden = true;
        isCompanyDeviceField.hidden = true;

        if (device != null) {
            idField.value = device.id;
            userIdField.value = device.userId;
            isCompanyDeviceField.value = device.isCompanyDevice;
            nameField.value = device.name;
            macField.value = device.mac;
        }

        const modalFields = new ModalFields(
            [idField, userIdField, isCompanyDeviceField, nameField, macField],
            new Config(''),
            false, false, false
        );

        modalFields.firebaePath = path;
        return modalFields;
    }
}



// WEBPACK FOOTER //
// ./src/models/device.ts